var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFillGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 92C20.5949 92 0 71.4051 0 46C0 20.5949 20.5949 0 46 0C71.4051 0 92 20.5949 92 46C92 71.4051 71.4051 92 46 92Z",
    fill: "#74BF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3895 71.5716C37.3754 71.5716 35.3614 70.7084 34.2105 68.9822L18.098 48.266C15.7962 45.3888 16.3718 41.3607 19.249 39.0588C22.1262 36.757 26.1543 37.3326 28.4561 40.2098L39.3895 54.3082L63.5585 22.9462C65.8604 20.0691 69.8885 19.4934 72.7656 21.7953C75.6428 24.0972 76.2184 28.1253 73.9166 31.0025L44.5686 68.982C43.1301 70.4208 41.4037 71.5716 39.3895 71.5716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFillGreen);
export default __webpack_public_path__ + "static/media/check-fill-green.0dca6859f89011a2d34cea5345813c7f.svg";
export { ForwardRef as ReactComponent };